import React from "react";

import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";

function AboutUsIntel() {
  const submitEvent = new SubmitEvent("submit");
  return (
    <section className="blogs-6">
      <Container>
        <Row>
          <Col className="mx-auto" lg="10">
            <h3 className="display-3 mt-5 mb-5">Latest Intel</h3>
            <Card
              className="card-blog card-background card-grande"
              data-animation="zooming"
            >
              <div
                className="full-background"
                style={{
                  backgroundImage:
                    "url(" +
                    require("assets/img/blogs/dominica.png") +
                    ")",
                }}
              ></div>
              <a href="/htx-mixing-service" onClick={submitEvent}>
                {" "}
              </a>
              <CardBody className="mb-4">
                <CardTitle tag="h2">
                  Is Huobi / HTX a &#8220;compliant&#8221; exchange or just a &#8220;regulated&#8221; 
                  mixing service?
                </CardTitle>
                <p className="card-description text-white">
                  A look into the exchange now known as HTX and the potential use as a mixing service 
                  for illicit actors
                </p>
                <div className="author">
                  <img
                    alt="..."
                    className="avatar bg-transparent"
                    src={require("assets/img/logo.png")}
                  ></img>
                </div>
                <br></br>
                <Button href="/htx-mixing-service" onClick={submitEvent} color="info">Read more...</Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default AboutUsIntel;
